import api from '@/api'

// const defaultOemInfo = {
//   name: '智投直通车',
//   icp: '京ICP备17066298号-2',
//   privateLogo: 'https://img.5aitui.com/zt/images/oem/ztztc/private-logo.svg',
//   publicLogo: 'https://img.5aitui.com/zt/images/oem/ztztc/public-logo.svg'
// }

export default {
  state: {
    oemInfo: {
      name: '',
      icp: '',
      privateLogo: '',
      publicLogo: ''
    }
  },

  mutations: {
    setOemInfo (state, info) {
      state.oemInfo = info
    }
  },

  actions: {
    getOemInfo ({ commit }, data) {
      return api.oem.getOemInfo(data).then(response => {
        commit('setOemInfo', {
          name: response.data.name,
          icp: response.data.icp,
          privateLogo: response.data.privateLogo,
          publicLogo: response.data.publicLogo
        })
        return response
      }).catch(() => {
        // No handler
      })
    }
  }
}
